//
// Generated class EventProgramImage
//

/// <reference path="EventProgramImage_ManagedObject.ts" />

class EventProgramImage extends EventProgramImage_ManagedObject
{
    removeFromMOC(save:boolean){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.managedObjectContext.deleteObject(this);
        if (save == true) ad.managedObjectContext.save();
    }
}
